import _concat from "lodash/concat";
import login from "./login";
import registration from "./registration";

export default {
  path: "/",
  component: () => import("@/layouts/AuthenticationLayout"),
  children: _concat(login, registration)
};
